/** Year columns newest-first, matching year/quarter filter order (descending years). */
export const getAllYearQuarters = (yearOptions: { value: number }[]) => {
  return [...yearOptions]
    .sort((a, b) => b.value - a.value)
    .map(option => ({
      year: option.value,
      quarters: [1, 2, 3, 4],
    }));
};

/**
 * Distinct years that actually have availability records, newest-first.
 * The timeline must only render years where data exists (work item #5283),
 * so columns are derived from the availability data rather than the full
 * list of years the cube knows about for the country.
 */
export const getYearsWithData = (scores: { year: number | null }[]): { value: number }[] => {
  const years = new Set<number>();
  for (const score of scores) {
    if (score.year !== null) years.add(score.year);
  }
  return Array.from(years)
    .sort((a, b) => b - a)
    .map(year => ({ value: year }));
};

export const getUserCountries = (fetchedUserCountries: { label: string; value: string }[]) => {
  return fetchedUserCountries
    .filter(country => country.label && country.value)
    .map(country => ({
      label: country.label.toString(),
      value: country.value,
    }));
};
